import React from "react";
import { classNames } from "../../shared/utility";
import RequiredFieldLabel from "./RequiredFieldLabel";

export default function Input(props) {
  const {
    parentClass,
    className,
    label,
    name,
    onChange,
    type,
    value,
    labelOn,
    error,
    explanation,
    ref,
    labelClass,
    required = false,
    ...other
  } = props;

  const labelClasses = classNames(
    labelClass ? labelClass : "text-sm",
    "block font-medium text-brand",
  );

  return (
    <div className={parentClass ? parentClass : null}>
      {labelOn ? (
        <div className="mb-1 flex space-x-2">
          {typeof label === "string" ? (
            <label htmlFor={name} className={labelClasses}>
              <RequiredFieldLabel required={required}>
                {label}
              </RequiredFieldLabel>
            </label>
          ) : (
            <div className={labelClasses}>
              <RequiredFieldLabel required={required}>
                {label}
              </RequiredFieldLabel>
            </div>
          )}
        </div>
      ) : null}
      <div>
        <input
          type={type}
          name={name}
          id={name}
          className={className ? className : "input-brand mt-1"}
          value={value}
          onChange={onChange}
          ref={ref}
          required={required}
          aria-required={required}
          {...other}
        />
        {error ? (
          <p className="mt-1 font-medium text-danger">{error}</p>
        ) : null}
        {explanation ? (
          <p className="mt-1 text-xs text-slate-500">{explanation}</p>
        ) : null}
      </div>
    </div>
  );
}
